// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2qTXg","row":"ProcedureTreatmentSummary_row__2QT7j"};